var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlaytn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 1975.1",
    style: {
      enableBackground: "new 0 0 2000 1975.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4F473B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1047.4,982.5l683.3,678.3c359.1-380.9,359.1-975.7,0-1356.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M997.5,1027.4l-673.3,668.3l673.3,279.3l673.3-279.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M972.6,957.6l698.3-693.3L1027.4,0L389,1541.2L972.6,957.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,982.5c-0.5,252.3,95.9,495.1,269.3,678.3l668.3-1611"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/klaytn.1a88abd3eee2951b2cc4646e7bdcfa98.svg";
export { ForwardRef as ReactComponent };